module.exports = __webpack_public_path__ + "media/images/Cata-7-b4d5da18b518e5e9495feb9cf0066345.jpg";